<template>
  <div></div>
</template>

<script>

import { mapState } from 'vuex';

const ONBOARDING_STATUS = {
  NEW: 'new',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
};

export default {
  name: 'StateRouter',
  async created() {
    const redirectPath = this.getRedirectPath();
    this.$router.replace({ path: redirectPath, query: this.$route.query });
  },
  computed: {
    ...mapState('customerState', ['onboardingStatus']),
    ...mapState('onboardingState', ['pageName']),
  },
  methods: {
    getRedirectPath() {
      if (this.pageName && this.onboardingStatus !== ONBOARDING_STATUS.COMPLETED) {
        return 'ob';
      }
      if (this.onboardingStatus === ONBOARDING_STATUS.NEW) {
        return 'onboard';
      }
      return 'home';
    },
  },
};
</script>
